module.exports = __webpack_public_path__ + "media/new/new-118c20c4.gif";